import { render, staticRenderFns } from "./resumo-formularios-declaracoes.vue?vue&type=template&id=11f5e92a&scoped=true"
import script from "./resumo-formularios-declaracoes.vue?vue&type=script&lang=js"
export * from "./resumo-formularios-declaracoes.vue?vue&type=script&lang=js"
import style0 from "./resumo-formularios-declaracoes.vue?vue&type=style&index=0&id=11f5e92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f5e92a",
  null
  
)

export default component.exports